import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import NotFound from "../pages/notfound/NotFound";
import Login from "../pages/login";
import Register from "../pages/register";
import JobSearch from "../pages/jobSearch";
import JobDetails from "../pages/jobDetails";
import UserDashboardLayout from "../components/Layouts/UserDashboard";
import UserDashboard from "../pages/userDashboard/pages";
import MyApplications from "../pages/userDashboard/pages/myApplications";
import MyApplicationDetails from "../pages/userDashboard/pages/myApplications/details";
import MyProfile from "../pages/userDashboard/pages/myProfile/profile";
import MyResumes from "../pages/userDashboard/pages/myResumes";
import ManageResume from "../pages/userDashboard/pages/myResumes/manageResume";
import EmailVerification from "../pages/register/EmailVerification";
import RecoverPassword from "../pages/recoverPassword/RecoverPassword";
import ConfirmRecover from "../pages/recoverPassword/Confirm";
import AboutUs from "../pages/aboutus/Index";

const AppRoutes = () => {

    return (
        <Router>
            <Routes>
                    <Route path="login" element={<Login/>} />
                    <Route path="register" element={<Register/>} />
                    <Route path="/password-reset" element={<RecoverPassword/>} />
                    <Route path="/password-reset/confirm/:uuid/:token" element={<ConfirmRecover/>} />
                    <Route path="accounts-confirm-email/:emailKey" element={<EmailVerification/>} />
                <Route element={<UserDashboardLayout/>}>
                    <Route index path="" element={<UserDashboard />} />
                    <Route path="search" element={<JobSearch/>} />
                    <Route path="about" element={<AboutUs/>} />
                    <Route path="job/:jobId/details" element={<JobDetails/>} />
                    <Route index path="" element={<UserDashboard />} />
                    {/* user dashboard */}
                    <Route path="my-applications" element={<MyApplications/>} />
                    <Route path="my-applications/:applicationId/details" element={<MyApplicationDetails/>} />
                    <Route path="profile" element={<MyProfile/>} />
                    <Route path="my-resumes" element={<MyResumes/>} />
                    <Route path="my-resumes/manage/:action" element={<ManageResume/>} />
                </Route>
                
                <Route path="*" element={<NotFound/>}/>
            </Routes>
        </Router>
    )
}

export default AppRoutes;